module.exports = __webpack_public_path__ + "static/img/business_chair_h9_r.0b01c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/business_chair_h9_r.png
// module id = Fx0K
// module chunks = 3